import './winmock3/style';
import FormStructure from './winmock3/form_structure';

export default FormStructure;